// src/components/Spinner.js
// Reusable loading indicator. Use inline (size="sm", inline) next to button text, or block-level
// (default) in place of a page/section's "Loading…" text.
import React from "react";
import "./Spinner.css";

const Spinner = ({ label, size = "md", inline = false }) => (
  <span className={`spinner-wrap ${inline ? "spinner-wrap-inline" : "spinner-wrap-block"}`}>
    <span className={`spinner spinner-${size}`} aria-hidden="true" />
    {label && <span className="spinner-label">{label}</span>}
  </span>
);

export default Spinner;
